/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type AuthenticationStatus = 0 | 1 | 2;

export const AuthenticationStatus = {
    NUMBER_0: 0 as AuthenticationStatus,
    NUMBER_1: 1 as AuthenticationStatus,
    NUMBER_2: 2 as AuthenticationStatus
};